import { render, staticRenderFns } from "./ShopCatalog.vue?vue&type=template&id=03fdf33f&scoped=true&"
import script from "./ShopCatalog.vue?vue&type=script&lang=js&"
export * from "./ShopCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ShopCatalog.vue?vue&type=style&index=0&id=03fdf33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fdf33f",
  null
  
)

export default component.exports